import { IonContent, IonButton, IonList, IonIcon, IonLabel, IonItem, IonHeader, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import "./Home.css";
import readerIcon from "../assets/reader.svg";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { mk_ion_header } from "../functions/mk_ion_header";

export default function Stationen() {
  const { appFunktion, appStationen, appStationChange, appStationenMenuesChange, appStationBezeichnungChange } = useContext(DataContext);
  return (
    <IonPage>
      { mk_ion_header( 'Wohnbereiche' ) }
      <IonContent fullscreen>
        { mk_ion_header( 'Wohnbereiche', 'large' ) }
        <IonButton routerLink={"/home"}>zurück</IonButton>

        <IonList>
          {appStationen && [
            appStationen.map((elementInArray: any) =>
              elementInArray.betriebe_wb_ausblenden === "true" ? (
                <IonItem
                  key={"betriebe_wb_" + elementInArray.betriebe_wb_id}
                  button
                  routerLink={"/" + appFunktion + "/" + elementInArray.betriebe_wb_id + "/" + elementInArray.betriebe_wb_name}
                  // routerLink={ '/funktionen/' + elementInArray.betriebe_wb_id + '/' + elementInArray.betriebe_wb_name }
                  onClick={() => {
                    appStationenMenuesChange(elementInArray.betriebe_anzahl_menues);

                    appStationChange(elementInArray.betriebe_wb_id);
                    appStationBezeichnungChange(elementInArray.betriebe_wb_name);
                  }}
                >
                  <IonIcon slot="start" icon={readerIcon}></IonIcon>
                  <IonLabel>{elementInArray.betriebe_wb_name}</IonLabel>
                </IonItem>
              ) : (
                ""
              )
            ),
          ]}
        </IonList>
      </IonContent>
    </IonPage>
  );
}
